import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=4a349bac&scoped=true&"
import script from "./Basket.vue?vue&type=script&lang=ts&"
export * from "./Basket.vue?vue&type=script&lang=ts&"
import style0 from "./Basket.vue?vue&type=style&index=0&id=4a349bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a349bac",
  null
  
)

export default component.exports